// import "../../assets/js/smtp.js" 
export default {
  data() {
    return {
      request: {
        name: "",
        email: "",
        phone: "",
        message: "",
        // captchaSum: ""

      },
      isNameValid: true,
      isPhoneValid: true,
      isEmailValid: true,
      isMessageValid: true,
      isMessageLengthValid: true,
      isCaptchaValid: true,
      isLoading: false,
      isSent: false,
      rendered: false,
      receivers: ["p.detchev@cdots.bg", "support@cdots.bg"]
    }
  },
  methods: {
    executeRecaptcha() {
      return new Promise((resolve, reject) => {
        grecaptcha.ready(() => {
          grecaptcha.execute(process.env.VUE_APP_RECAPTCHA_SITE_KEY, { action: 'submit_form' })
            .then((token) => {
              resolve(token);
            })
            .catch((error) => {
              console.error('Error executing reCAPTCHA:', error);
              reject(error);
            });
        });
      });
    },
    async sendInquiry(specification, solution) {
      this.isLoading = true;

      if (this.isValid()) {
        const token = await this.executeRecaptcha();
        this.request.recaptchaToken = token;

        this.request.specification = specification

        if (typeof solution !== 'undefined' && solution) {
          this.request.solution = solution
          this.request.pageLocation = window.location.href
        }

        fetch(`${process.env.VUE_APP_BASE_URI}/email/inquiry`, {
          method: "post",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(this.request),
        })
          .then((response) => {
            {
              if (!response.ok) {
                return console.log(response);
              }
              return response.json();
            }
          })
          .then((data) => {
            if (data) {
              if (data && data.success) {
                this.request = {
                  name: "",
                  email: "",
                  phone: "",
                  message: "",
                  // captchaSum: "",
                  solution: "",
                  pageLocation: "",
                  specification: "",
                };
                this.isSent = true;
                this.rendered = false;
                setTimeout(() => {
                  this.isLoading = false;
                  this.isSent = false;
                  this.rendered = true;
                }, 5000);
              } else {
                console.log(data.error);
              }
            }
          })
          .catch((err) => {
            console.log(err), (this.isFormSend = false);
          })
        // const emailTitle = 'Запитване от cDots.bg' + specification

        // Email.send(
        //   "notifications@cdots.bg",
        //   this.receivers,
        //   emailTitle,
        //   `
        //   Здравейте,<br><br>
        //   Имате ново запитване<strong>${specification}</strong> от cDots.bg:<br><br>
        //   Име: <strong>${this.request.name}</strong>,<br><br>
        //   E-mail: <strong>${this.request.email}</strong>,<br><br>
        //   Телефон: <strong>${this.request.phone}</strong>,<br><br>` +
        //   (typeof solution !== 'undefined' && solution ? `Решение: <strong>${solution}</strong>,<br><br>` : '') +
        //   (typeof solution !== 'undefined' && solution ? `Страница: <strong>${window.location.href}</strong>,<br><br>` : '') +
        //   `
        //   Съобщение: <strong>${this.request.message}</strong><br><br>

        //   Това е автоматичен e-mail моля не отговаряйте.
        //   `, {
        //     token: "f038171e-cd38-4ecf-99bf-c59583653252",
        //     callback: message => {
        //       console.log(message)
        //       // reset request inputs
        //       this.request = {
        //         name: "",
        //         email: "",
        //         phone: "",
        //         message: "",
        //         captchaSum: ""
        //       };
        //       this.isSent = true;
        //       this.rendered = false;
        //       setTimeout(() => {
        //         this.isLoading = false;
        //         this.isSent = false;
        //         this.rendered = true;
        //       }, 5000);

        //     }
        //   }
        // )
      } else {
        this.isLoading = false;
        setTimeout(() => {
          this.isNameValid = true;
          this.isPhoneValid = true;
          this.isEmailValid = true;
          this.isMessageValid = true;
          this.isMessageLengthValid = true;
          this.isCaptchaValid = true;
        }, 3000);
      }
    },
    isValid() {
      if (this.request.name.length < 1 || this.request.name.length > 50) {
        this.isNameValid = false;
      }
      if (this.request.phone.length < 1 || this.request.phone.length > 20) {
        this.isPhoneValid = false;
      }
      if (!this.validateEmail(this.request.email)) {
        this.isEmailValid = false;
      }
      // if (!this.request.captchaSum) {
      //   this.isCaptchaValid = false;
      // }
      // if (Number(this.request.captchaSum) !== this.captcha.sum) {
      //   this.isCaptchaValid = false;
      // }
      if (
        this.request.message.length < 1 ||
        this.request.message.length > 1600
      ) {
        this.isMessageLengthValid = false;
      }
      if (!this.request.message.length) {
        this.isMessageValid = false;
      }
      if (
        !this.isNameValid ||
        !this.isPhoneValid ||
        !this.isEmailValid ||
        !this.isMessageValid ||
        !this.isMessageLengthValid ||
        !this.isCaptchaValid
      ) {
        return false;
      }
      return true;
    },
    validateEmail(email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/sendInquiry.js